<template>
  <div id="scroll-target">
    <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner ">
      <vs-tab label="Registration">
        <RegistrationTable></RegistrationTable>
      </vs-tab>
      <vs-tab label="RSVP">
        <RSVPTable></RSVPTable>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx";
import RSVPTable from "@/components/soldoutt/tables/RSVPTable.vue";
import RegistrationTable from "../../../components/soldoutt/tables/RegistrationTable.vue"; // import xlsx
export default {
  components: { RSVPTable, RegistrationTable },
  data: () => ({}),
  watch: {},
  created() {},
  methods: {}
};
</script>
